import { Injectable } from "@angular/core";
import { LogoService } from "../logo.service";
import { ConfigService } from "./config.service";

// src/app/services/asset.service.ts
@Injectable({
    providedIn: 'root'
})
export class AssetService {

    private cliente = 'default';

    constructor(
        private _logoService: LogoService
    ) {
    }

    public loadAssets(client: string) {
        this.cliente = client || 'default';
        this.applyFavicons();
        this._logoService.Logo = this.getLogoPath();
    }

    public getLogoPath(): string {
        if (this.cliente == 'btg') {
            //btg usa svg
            return `assets/${this.cliente}/imgs/logo2.svg`;
        }
        return `assets/${this.cliente}/imgs/logo.png`;
    }
    public getLoginImgPath(): string {
        return `assets/${this.cliente}/imgs/login-image.png`;
    }

    public getFavicon(size: '16x16' | '32x32' | 'apple'): string {
        switch (size) {
            case '16x16':
                return `assets/${this.cliente}/icon/favicon-16x16.png`;
            case '32x32':
                return `assets/${this.cliente}/icon/favicon-32x32.png`;
            case 'apple':
                return `assets/${this.cliente}/icon/apple-touch-icon.png`;
            default:
                return `assets/${this.cliente}/icon/favicon-16x16.png`;
        }
    }

    async getTutorialPdfPath(): Promise<string> {
        const path = `assets/${this.cliente}/documents/tutorial.pdf`;

        try {
            const res = await fetch(path, { method: 'HEAD' });
            if (res.ok) {
                return path;
            } else {
                return 'assets/documents/tutorial.pdf';
            }
        } catch {
            return 'assets/documents/tutorial.pdf';
        }
    }


    private applyFavicons(): void {
        this.updateOrCreateLink('favicon-16x16', this.getFavicon('16x16'), 'image/png', '16x16');
        this.updateOrCreateLink('favicon-32x32', this.getFavicon('32x32'), 'image/png', '32x32');
        this.updateOrCreateLink('apple-touch-icon', this.getFavicon('apple'), 'image/png');
    }

    private updateOrCreateLink(id: string, href: string, type: string, sizes?: string) {
        let link = document.getElementById(id) as HTMLLinkElement;

        if (!link) {
            link = document.createElement('link');
            link.id = id;
            link.rel = id === 'apple-touch-icon' ? 'apple-touch-icon' : 'icon';
            document.head.appendChild(link);
        }

        link.setAttribute('type', type);
        link.setAttribute('href', href);
        if (sizes) {
            link.setAttribute('sizes', sizes);
        }
    }
}
